<template>
  <b-row>
    <b-col
      cols="12"
      md="6"
    >
      <b-overlay
        :show="isPending"
        rounded="sm"
      >
        <b-card>
          <validation-observer ref="simpleRules">
            <b-form @submit.prevent="validationForm">

              <!-- Nama -->
              <b-form-group
                label="Nama"
                label-for="v-name"
                label-cols-md="4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Nama"
                  rules="required"
                >
                  <b-form-input
                    id="v-name"
                    v-model="form.name"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Key -->
              <b-form-group
                label="Key"
                label-for="v-key"
                label-cols-md="4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Key"
                  rules="required"
                >
                  <b-form-input
                    id="v-key"
                    v-model="form.key"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Type -->
              <b-form-group
                label="Tipe Pengaturan"
                label-for="v-type"
                label-cols-md="4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Tipe Pengaturan"
                  rules="required"
                >
                  <v-select
                    v-model="form.type"
                    label="Tipe"
                    :options="typeOptions"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Pilih Tipe Pengaturan"
                    @input="onChangeSelect"
                  >
                    <template #selected-option="{ Tipe }">
                      {{ listTypeOption.find(el => el.value === Tipe).title }}
                    </template>
                    <template #option="{ Tipe }">
                      {{ listTypeOption.find(el => el.value === Tipe).title }}
                    </template>
                    <template #no-options="">
                      Tipe tidak ditemukan.
                    </template>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <div v-if="form.type">
                <hr>
                <!-- Value -->
                <b-form-group
                  label="Value"
                  label-for="v-value"
                  label-cols-md="4"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Value"
                    rules="required"
                  >
                    <b-form-input
                      v-if="form.type === 'text'"
                      id="v-value"
                      v-model="form.value"
                      :state="errors.length > 0 ? false : null"
                    />

                    <b-input-group
                      v-if="form.type === 'number'"
                    >
                      <cleave
                        id="v-minimum-transaction"
                        v-model="form.value"
                        class="form-control"
                        :class="{'is-invalid' : errors.length > 0}"
                        :raw="true"
                        :options="options.number"
                      />
                    </b-input-group>

                    <b-form-checkbox
                      v-if="form.type === 'boolean'"
                      id="v-value"
                      v-model="form.value"
                      :checked="form.value"
                      switch
                      inline
                    />

                    <b-form-textarea
                      v-if="form.type === 'longtext'"
                      id="v-value"
                      v-model="form.value"
                      rows="3"
                      :state="errors.length > 0 ? false : null"
                    />

                    <b-form-file
                      v-if="form.type === 'file'"
                      id="v-value"
                      v-model="form.value"
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                    />

                    <form-image
                      v-if="form.type === 'image'"
                      id="v-value"
                      v-model="form.value"
                      label="Pilih Gambar"
                      :state="errors.length > 0 ? false : null"
                      @finish="setImageFile"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </div>

              <!-- Button -->
              <div class="d-flex justify-content-end mt-3">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  :disabled="isSubmitting"
                >
                  <b-spinner
                    v-if="isSubmitting"
                    small
                  />
                  {{ isSubmitting ? "Menyimpan" : "Simpan" }}
                </b-button>
              </div>
            </b-form>
          </validation-observer>
        </b-card>
      </b-overlay>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import vSelect from 'vue-select'
import FormImage from '@/layouts/components/custom/FormImage.vue'
import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BSpinner,
  BOverlay,
  BFormCheckbox,
  BFormTextarea,
  BFormFile,
  BInputGroup,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import Cleave from 'vue-cleave-component'

// Vee Validate
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BOverlay,
    BSpinner,
    BFormCheckbox,
    BFormTextarea,
    BFormFile,
    BInputGroup,

    ValidationProvider,
    ValidationObserver,

    vSelect,
    FormImage,
    Cleave,
  },
  directives: {
    Ripple,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        name: '',
        key: '',
        value: '',
        type: '',
        imageFile: '',
      },
      required,
      isPending: false,
      isSubmitting: false,
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralDecimalMark: ',',
          delimiter: '.',
          numeralPositiveOnly: true,
        },
      },
    }
  },
  computed: {
    ...mapState('setting', ['setting', 'listTypeOption']),
    settingKey() {
      if (this.isEdit) {
        return this.$route.params.key
      }
      return null
    },
    typeOptions() {
      return this.listTypeOption.filter(ex => ex.active === true).map(el => el.value)
    },
  },
  async created() {
    this.isPending = true

    if (this.isEdit) {
      await this.getSetting({ key: this.settingKey })
      this.fillData()
    }

    this.isPending = false
  },
  methods: {
    ...mapActions('setting', ['createSetting', 'updateSetting', 'getSetting']),
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.handleSubmit()
        }
      })
    },
    async handleSubmit() {
      this.isSubmitting = true

      if (!this.isEdit) {
        await this.createSetting(this.form)
      } else {
        await this.updateSetting({ settingKey: this.settingKey, data: this.form })
      }

      this.isSubmitting = false
      this.$router.push('/settings')
    },
    // Edit State Only
    fillData() {
      this.form.name = this.setting.name
      this.form.key = this.setting.key
      this.form.value = this.setting.value

      this.form.type = this.setting.type
      const checkType = this.listTypeOption.find(el => el.value === this.form.type)
      if (checkType && !checkType.active) this.form.type = null

      if (this.form.type === 'boolean') this.form.value = this.form.value === '1'
    },
    onChangeSelect(value) {
      if (value === 'text') this.form.value = ''
      if (value === 'boolean') this.form.value = false
      if (value === 'longtext') this.form.value = ''
      if (value === 'number') this.form.value = null
      if (value === 'file') this.form.value = null
      if (value === 'image') this.form.value = null

      this.$refs.simpleRules.reset()
    },
    setImageFile(file) {
      if (file) {
        this.form.imageFile = file
      }
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
